const state = {
  interactiveData: {},
};

const mutations = {
  CHANGE_INTERACTIVE_CONTENT(state, interactiveObj) {
    state.interactiveData = interactiveObj;
  },
};

const actions = {
  someAsyncTask({ commit }) {
    // do something async
    commit('TEST');
  },
};

const getters = {
  interactiveData: (state) => {
    return state.interactiveData;
  },
};
export default {
  state,
  mutations,
  actions,
  getters,
};
